<div class="what-is-pp-container">
  <ion-list>
    <ion-item lines="none">
      <ion-button slot="start"
                  (click)="onCancelButtonClick()"
                  color="light"
                  shape="round">
        <i class="far fa-times-circle icon"></i>
        Cancel
      </ion-button>

      <ion-text class="help-header">What is Promo Portal?</ion-text>
    </ion-item>
  </ion-list>

  <ion-list lines="none" class="scrollable">
    <ion-item>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi culpa delectus hic illo ipsa itaque iusto,
      molestias neque officiis, omnis quae quidem quisquam repellat repellendus repudiandae suscipit, ut veritatis
      vitae.
    </ion-item>
  </ion-list>
</div>
